import { render, staticRenderFns } from "./bind-menu.vue?vue&type=template&id=734daa33"
import script from "./bind-menu.vue?vue&type=script&lang=js"
export * from "./bind-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports